import React, { useEffect, useState } from "react";
import { Box, Input, Option, Select } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EmptyData from "../components/EmptyData";
import CustomPagination from "../components/CustomPagination";
import { user_dispute } from "../reduxData/user/userAction";
import DefaultImg from "../images/no_profile.png";
import { VIEW_ITEM_DETAIL } from "../reduxData/user/userTypes";
import ViewDetail from "../Modals/ViewDetail";
import ResolutionModal from "../Modals/ResolutionModal";

const DisputesList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { disputes, disputesTotal } = useSelector((state) => state.user);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [isPop, setIsPop] = useState(false);
  const [showResolveModal, setShowResolveModal] = useState(false);
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const resolutionActions = [
    { label: "Side with Seller", value: "RESOLVED_FAVOR_SELLER" },
    { label: "Side with Buyer", value: "RESOLVED_FAVOR_BUYER" },
    { label: "Dismiss Dispute", value: "DISMISSED" },
  ];

  useEffect(() => {
    user_dispute(dispatch, page, pageSize, search, "get", null);
  }, [dispatch, page, pageSize, search]);

  const handleResolutionSelect = (dispute, resolution) => {
    if (!resolution) return;
    setSelectedData({ dispute, resolution });
    setShowResolveModal(true);
  };

  const handleConfirmResolution = async (resolution, resolutionAction) => {
    if (!selectedData?.dispute) return;

    await user_dispute(dispatch, page, pageSize, search, "resolve", {
      id: selectedData.dispute._id,
      resolution: resolution,
      resolutionAction: resolutionAction,
    });
  };

  const handleOpenResolveModal = (dispute) => {
    setSelectedDispute(dispute);
    setShowResolveModal(true);
  };

  const renderResolvedBadge = (resolution) => {
    let badgeClass = "bg-secondary";
    let text = resolution.replace(/_/g, " ");

    if (resolution.includes("SELLER")) badgeClass = "bg-success";
    if (resolution.includes("BUYER")) badgeClass = "bg-info text-dark";
    if (resolution === "DISMISSED") badgeClass = "bg-light text-dark";

    return <span className={`badge ${badgeClass}`}>{text}</span>;
  };

  return (
    <div>
      <div className="container">
        <Box className="d-flex mb-4 justify-content-between align-items-center">
          <h3 className="mb-0 fw-600">{`Disputes (${disputesTotal || 0})`}</h3>
          <div className="d-flex justify-content-end align-items-center">
            <Input
              className="form-control"
              type="text"
              placeholder="Search by reason..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Box>
        <div className="table-responsive">
          <table className="table user-management-table table-hover align-middle">
            <thead className="border-gray">
              <tr>
                <th style={{ minWidth: "250px" }}>Parties Involved</th>
                <th style={{ minWidth: "200px" }}>Item</th>
                <th style={{ minWidth: "250px" }}>Reason</th>
                <th style={{ minWidth: "200px" }}>Resolution Actions</th>
              </tr>
            </thead>
            <tbody>
              {disputesTotal > 0 ? (
                disputes.map((dispute) => (
                  <tr key={dispute._id}>
                    <td>
                      <div className="mb-2">
                        <small className="text-muted d-block">INITIATOR</small>
                        <div
                          className="d-flex align-items-center cursor-pointer"
                          onClick={() =>
                            navigate(`/editUser/${dispute?.initiator?._id}`)
                          }
                        >
                          <img
                            src={dispute?.initiator?.profile_pic || DefaultImg}
                            style={{ width: 35, height: 35, borderRadius: 75 }}
                            className="object-fit-cover me-2"
                            alt="initiator"
                          />
                          <div>
                            <span className="fw-semibold d-block">
                              {dispute?.initiator?.user_name}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <small className="text-muted d-block">ACCUSED</small>
                        <div
                          className="d-flex align-items-center cursor-pointer"
                          onClick={() =>
                            navigate(`/editUser/${dispute?.accused?._id}`)
                          }
                        >
                          <img
                            src={dispute?.accused?.profile_pic || DefaultImg}
                            style={{ width: 35, height: 35, borderRadius: 75 }}
                            className="object-fit-cover me-2"
                            alt="accused"
                          />
                          <div>
                            <span className="fw-semibold d-block">
                              {dispute?.accused?.user_name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => {
                        setIsPop(true);
                        dispatch({
                          type: VIEW_ITEM_DETAIL,
                          payload: dispute?.itemId,
                        });
                      }}
                    >
                      <img
                        src={dispute?.itemId?.photos?.[0]}
                        height={50}
                        width={65}
                        alt="item"
                        className="object-fit-cover rounded d-block mb-1"
                      />
                      <span className="text-dark small text-truncate-2">
                        {dispute?.itemId?.item_name || "N/A"}
                      </span>
                    </td>
                    <td>
                      <small className="text-muted d-block mb-1">
                        CREATED:{" "}
                        {new Date(dispute.createdAt).toLocaleDateString()}
                      </small>
                      <span
                        className={`badge mb-2 ${
                          dispute.disputeType === "SELLER_ISSUE"
                            ? "bg-primary"
                            : "bg-warning text-dark"
                        }`}
                      >
                        {dispute.disputeType?.replace("_", " ")}
                      </span>
                      <p className="mb-1 fw-bold">{dispute?.reason}</p>
                      <p className="mb-2 text-muted small">
                        {dispute?.description}
                      </p>

                      <div className="mt-2 pt-2 border-top">
                        <small className="text-muted d-block">
                          USER'S DESIRED OUTCOME
                        </small>
                        <span className="fw-semibold">
                          {dispute.desiredOutcome?.replace(/_/g, " ")}
                        </span>
                        {dispute.desiredOutcome === "other" && (
                          <p className="text-muted small fst-italic">
                            "{dispute.desiredOutcomeOther}"
                          </p>
                        )}
                      </div>
                    </td>
                    <td>
                      {dispute.resolution === "PENDING_REVIEW" ? (
                        <Select
                          defaultValue=""
                          onChange={(e, value) =>
                            handleResolutionSelect(dispute, value)
                          }
                        >
                          <Option value="" disabled>
                            Select Resolution...
                          </Option>
                          {resolutionActions.map((action) => (
                            <Option key={action.value} value={action.value}>
                              {action.label}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        renderResolvedBadge(dispute.resolution)
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">
                    <EmptyData />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="mt-3">
          {disputesTotal > pageSize && (
            <CustomPagination
              total={disputesTotal}
              onPageChange={(page, perPage) => {
                setPage(page);
                setPageSize(perPage);
              }}
            />
          )}
        </div>
      </div>
      <ViewDetail
        show={isPop}
        handleClose={() => {
          setIsPop(false);
          dispatch({ type: VIEW_ITEM_DETAIL, payload: null });
        }}
      />
      <ResolutionModal
        show={showResolveModal}
        onHide={() => setShowResolveModal(false)}
        selectedData={selectedData}
        onConfirm={handleConfirmResolution}
      />
    </div>
  );
};

export default DisputesList;
